/** KAN-851: ряд чипов фильтра по теплоте лида: Все / Горячие / Тёплые / Прохладные / Ледяные. */
import { cn } from '@/lib/utils';
import {
  LEAD_TEMPERATURE_FILTER_LABELS,
  LEAD_TEMPERATURE_FILTERS,
  type LeadTemperatureFilter,
} from '@/lib/leadTemperature';

interface MobileTemperatureChipsProps {
  value: LeadTemperatureFilter;
  onChange: (value: LeadTemperatureFilter) => void;
}

export function MobileTemperatureChips({ value, onChange }: MobileTemperatureChipsProps): JSX.Element {
  return (
    <div role="group" aria-label="Теплота" className="-mx-4 mb-3 flex gap-2 overflow-x-auto px-4 pb-1">
      {LEAD_TEMPERATURE_FILTERS.map((filter) => {
        const active = filter === value;
        return (
          <button
            key={filter}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(filter)}
            data-testid={`mobile-temperature-chip-${filter}`}
            className={cn(
              'min-h-[40px] shrink-0 rounded-full border px-4 text-sm font-medium',
              active ? 'border-blue-600 bg-blue-600 text-white' : 'border-gray-300 bg-white text-gray-700 active:bg-gray-100'
            )}
          >
            {LEAD_TEMPERATURE_FILTER_LABELS[filter]}
          </button>
        );
      })}
    </div>
  );
}
